import { ActionIcon, ActionIconProps, Stack } from '@mantine/core'
import { IconRefresh } from '@tabler/icons-react'
import React, { useCallback, useState } from 'react'

import classes from './RefreshButton.module.css'

const spinning = {
  animation: 'spin 2s linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(360deg)',
    },
    '100%': {
      transform: 'rotate(0deg)',
    },
  },
}

interface RefreshButtonProps extends ActionIconProps {
  refetch?: () => Promise<any>
  noButton?: boolean
  loading?: boolean
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  refetch,
  noButton = false,
  loading = false,
  ...props
}) => {
  const [refetching, setRefetching] = useState(false)

  const reload = useCallback(() => {
    setRefetching(true)
    if (refetch) refetch().finally(() => setRefetching(false))
  }, [refetch])

  const styles = refetching ? spinning : {}

  return (
    <>
      {noButton ? (
        <Stack style={loading ? spinning : {}}>
          <IconRefresh size="14pt" />
        </Stack>
      ) : (
        <ActionIcon
          onClick={reload}
          {...props}
          className={classes.refresh}
          style={{
            ...styles,
          }}
        >
          <IconRefresh size="14pt" />
        </ActionIcon>
      )}
    </>
  )
}

export default RefreshButton
